import { useState } from "react";

type UsePaginationOptions = {
  defaultPage?: number;
};

export function usePagination({ defaultPage = 1 }: UsePaginationOptions = {}) {
  const [currentPage, setCurrentPage] = useState(defaultPage);

  function onPageChange(page: number) {
    setCurrentPage(page);
  }

  function resetPage() {
    setCurrentPage(defaultPage);
  }

  return { currentPage, onPageChange, resetPage };
}
